const FragmentDataType = Object.freeze({
    Player: "Player",
    Players: "Players",
    FieldPosition: "FieldPosition",
    Team: "Team",
    PenaltyType: "PenaltyType",
    PenaltyDownType: "PenaltyDownType",
    PatPenaltyDownType: "PatPenaltyDownType",
    Time: "Time",
    TimeAndPeriod: "TimeAndPeriod",
    SetTimeAndPeriod: "SetTimeAndPeriod",
    PatScoreType: "PatScoreType",
    PatPoints: "PatPoints",
    UpdateContext: "UpdateContext",
    CoinToss: "CoinToss",
    SwapTeams: "SwapTeams",
    RushType: "RushType",
    PassType: "PassType",
    Boolean: "Boolean"
});

export default FragmentDataType;
